import { TranslationType } from "../../types/translationTypes";
import { useSelector } from "react-redux";

export const getDictionary = (translation: TranslationType[], component: string, language: string) => {
  let dictionary = Array.isArray(translation) ? translation.filter((row) => row?.page === component) : [];
  return dictionary;
};

const humanizeKey = (key: string) => {
  if (!key) return "";
  // Preserve obvious abbreviations/units.
  if (/^[A-Z0-9]+$/.test(key)) return key;
  // If it's already a normal phrase, keep it.
  if (/\s/.test(key) && /[A-Za-z]/.test(key)) {
    return key.charAt(0).toUpperCase() + key.slice(1);
  }
  const parts = key
    .replace(/[_]+/g, "-")
    .split("-")
    .filter(Boolean);
  if (parts.length === 0) return key;
  return parts
    .map((p) => (p.length ? p.charAt(0).toUpperCase() + p.slice(1) : p))
    .join(" ");
};

/**
 * Convenience hook to access the current language + dictionary for a page key.
 * This avoids wiring `connect()` in small components.
 */
export const useDictionary = (pageName: string) => {
  const translation = useSelector((state: any) => state?.translation?.translation);
  const language = useSelector((state: any) => state?.translation?.language || "english");
  const dictionary = getDictionary(translation, pageName, language);
  return { dictionary, language };
};


// if (dictionary) {

//   if (dictionary?.length === 0 || !dictionary[0]?.values ||
//     !dictionary[0]?.values[field]) {
//     return "No trans";
//   }
//   const value = dictionary[0]?.values[field][language] ?
//     dictionary[0]?.values[field][language] :
//     dictionary[0]?.values[field]["english"] ?
//       dictionary[0]?.values[field]["english"] : "No translation";
//   return value;
// }
export const getField = (dictionary: any, field: string, language: string) => {
  if (dictionary?.length === 0 || !dictionary[0]?.values ||
    !dictionary[0]?.values[field]) {
    return "No trans";
  }
  const value = dictionary[0]?.values[field][language] ?
    dictionary[0]?.values[field][language] :
    dictionary[0]?.values[field]["english"] ?
      dictionary[0]?.values[field]["english"] : "No translation";
  return value;
}


const checkObjectValues = (obj: any) => {
  return Object.keys(obj).every(key => {
    const value = obj[key];
    return value === '' || value === null || value === undefined;
  });
}

export const getDataFieldTranslation = (dataObject: any, language: string) => {
  if (!dataObject) {
    return "";
  }
  if (checkObjectValues(dataObject)) {
    return "";
  }
  //else
  return (dataObject[language] ? dataObject[language] :
    dataObject["english"] ? dataObject["english"] : "No translation")
}

